module.exports = __webpack_public_path__ + "b4468cb5f33c6ce6660484f7d90f34a0.jpg";